import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0454124e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1))
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Vincular usuário com vendedor no ERP")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "ui-card" }
const _hoisted_14 = { class: "ui-card-body" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Remover vínculo")
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_33 = { class: "ant-input-affix-wrapper" }
const _hoisted_34 = { class: "ant-input-prefix" }
const _hoisted_35 = {
  role: "img",
  "aria-label": "user",
  type: "user",
  class: "anticon anticon-user"
}
const _hoisted_36 = {
  key: 0,
  class: "ui-table"
}
const _hoisted_37 = { class: "ui-rows ui-rolagem-padrao" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-18 ui-cell ui-ellipsis",
  "data-title": "Nome"
}
const _hoisted_40 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-6 ui-cell ui-ellipsis",
  "data-title": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_senha = _resolveComponent("campo-senha")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_ctx.verificaIntegracaoErpVendedor())
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ui-button -second",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prepararBuscaVendedores()))
              }, _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_12)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.usuario.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.usuario.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (_ctx.verificaIntegracaoErpVendedor())
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          label: "Usuário"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "255",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.usuario.email) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.usuario.email]
                            ])
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 1,
                          label: "E-mail"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.usuario.email,
                              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.usuario.email) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        }))
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, { label: "Senha" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_senha, {
                          valor: _ctx.state.usuario.senha,
                          "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.usuario.senha) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Telefone" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_telefone, {
                          valor: _ctx.state.usuario.telefone,
                          "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.usuario.telefone) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, { label: "Confirmado" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_sim_nao, {
                          radioButton: true,
                          valor: _ctx.state.usuario.confirmado,
                          "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.usuario.confirmado) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, { label: "Data Cadastro" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.usuario.dataCadastro,
                          "onUpdate:dataSelecionada": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.usuario.dataCadastro) = $event))
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.usuario.status,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.usuario.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativo")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativo")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (!_ctx.UtilitarioGeral.validaLista(_ctx.state.vinculos))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Permissões")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.privilegios, (permissao) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: permissao.identificador,
                            class: "ant-col ant-col-xs-24 ant-col-xl-12"
                          }, [
                            _createVNode(_component_a_checkbox, {
                              checked: permissao.valor,
                              "onUpdate:checked": ($event: any) => ((permissao.valor) = $event)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(permissao.descricao), 1)
                              ]),
                              _: 2
                            }, 1032, ["checked", "onUpdate:checked"])
                          ]))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.verificaIntegracaoErpVendedor() && _ctx.UtilitarioGeral.validaLista(_ctx.state.vinculos))
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 1,
                      titulo: "Vínculo com Vendedor no ERP"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.UtilitarioGeral.validaLista(_ctx.state.vinculos))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.vinculos, (vinculo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'VINC' + index,
                                  class: "ant-col ant-col-xs-24 ant-col-xl-6"
                                }, [
                                  _createVNode(_component_a_form_item, {
                                    label: vinculo.tipo === _ctx.ETipoVinculo.UsuarioVendedor?'Código Vendedor':'Código Zona de Venda'
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        maxlength: "255",
                                        class: "ant-input",
                                        "onUpdate:modelValue": ($event: any) => ((vinculo.codigoRelacionado) = $event),
                                        disabled: ""
                                      }, null, 8, _hoisted_27), [
                                        [_vModelText, vinculo.codigoRelacionado]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"])
                                ]))
                              }), 128)),
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(_component_a_form_item, { label: " " }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      class: "ui-button -second ui-mh-32",
                                      type: "button",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removerVinculos()))
                                    }, _hoisted_30)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                              key: 1,
                              mensagem: "Nenhum vendedor foi vinculado com este usuário."
                            }))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_a_drawer, {
          visible: _ctx.state.apresentarSelecaoVendedores,
          "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.apresentarSelecaoVendedores) = $event)),
          class: "custom-class",
          width: "600",
          title: "Vendedores no ERP",
          placement: "right"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, [
                      _createVNode(_component_icone, { nome: "pesquisar" })
                    ])
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Digite o nome do Vendedor",
                    type: "text",
                    class: "ant-input",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.buscaVendedor.nome) = $event)),
                    onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.buscarVendedores()))
                  }, null, 544), [
                    [_vModelText, _ctx.state.buscaVendedor.nome]
                  ])
                ])
              ])
            ]),
            _createVNode(_component_a_spin, {
              spinning: _ctx.state.buscandoVendedores,
              tip: "Buscando vendedores no ERP"
            }, {
              default: _withCtx(() => [
                (_ctx.UtilitarioGeral.validaLista(_ctx.state.vendedoresErp))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.vendedoresErp, (vendedorErp) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: vendedorErp.codigo,
                            class: "ant-row ui-row ui-selecao-vendedor",
                            onClick: ($event: any) => (_ctx.confirmarSelecaoVinculo(vendedorErp))
                          }, [
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("span", null, _toDisplayString(vendedorErp.codigo) + " - " + _toDisplayString(vendedorErp.nome), 1)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("span", null, "Zona: " + _toDisplayString(vendedorErp.informacaoAdicional), 1)
                            ])
                          ], 8, _hoisted_38))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["spinning"])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}